var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPuzzleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twotone-3d_rotation-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3727",
    "data-name": "Caminho 3727",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3728",
    "data-name": "Caminho 3728",
    d: "M19,13H17V7H11V5a.5.5,0,0,0-1,0V7H4l.01,2.12A4.7,4.7,0,0,1,4,17.88V20H6.12a4.7,4.7,0,0,1,8.76,0H17V14h2a.5.5,0,0,0,0-1Z",
    fill: "rgba(46,128,195,0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3729",
    "data-name": "Caminho 3729",
    d: "M19,11V7a2.006,2.006,0,0,0-2-2H13A2.5,2.5,0,0,0,8,5H4A2,2,0,0,0,2.01,7v3.8H2.3a2.7,2.7,0,0,1,0,5.4H2V20a2.006,2.006,0,0,0,2,2H7.8v-.3a2.7,2.7,0,1,1,5.4,0V22H17a2.006,2.006,0,0,0,2-2V16a2.5,2.5,0,0,0,0-5Zm0,3H17v6H14.88a4.7,4.7,0,0,0-8.76,0H4V17.88a4.7,4.7,0,0,0,.01-8.76L4,7h6V5a.5.5,0,0,1,1,0V7h6v6h2a.5.5,0,0,1,0,1Z",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleIcon);
export default __webpack_public_path__ + "static/media/puzzle-icon.c93a0e2e7a6cbc258f0c5c7e2e1408a1.svg";
export { ForwardRef as ReactComponent };